module.exports = __webpack_public_path__ + "static/img/banner03.1e50fd82.png";